import { TypedUseSelectorHook, useSelector } from "react-redux";

import { Store } from "./store.model";

export const useAppSelector: TypedUseSelectorHook<Store> = useSelector;
